import { render, staticRenderFns } from "./GradingImport.vue?vue&type=template&id=8f276c38"
import script from "../../controllers/grading/grading-import.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading/grading-import.js?vue&type=script&lang=js&external"
import style0 from "./GradingImport.vue?vue&type=style&index=0&id=8f276c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports